module.exports = __webpack_public_path__ + "static/media/add_cards.1bc82cbc.jpg";